import React from "react";
import '../styles/ContactUs.css';// Import CSS file
import emailIcon from "../images/email-icon.png";
import callIcon from "../images/phone-icon.png";
import addressIcon from "../images/location-icon.png";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';
import scanIcon from "../images/scan.jpg";

const ContactUs = () => {
  return (
    <div className="contact-container">
       <Header />
      <h2 className="h2class">Contact Us</h2>
      
      <div className="contact-info">
        <div className="info-box">
          <img src={emailIcon} alt="About" />
          <h3>EMAIL</h3>
          <p>admin@drivergems.com</p>
        </div>
<div className="info-box">
          
          <h3>SCAN ME</h3>
          <img src={scanIcon} alt="Scan Me" style={{width: "125px"}}/>
        </div>
        

        <div className="info-box">
          <img src={addressIcon} alt="Location" />
          <h3>OUR OFFICE LOCATION</h3>
          <p>DriverGems Tech Pvt. Ltd.</p>
          <p>Rahatani, Pune, Maharashtra, India,411017.</p>
        </div>
       
<div className="info-box">
          <img src={callIcon} alt="Phone" />
          <h3>PHONE (MOBILE)</h3>
          <p>+91 79900 94431 / +91 95293 03113</p>
        </div>
      </div>
      <WhatsAppButton/>
      <Footer/>
    </div>
  );
};

export default ContactUs;
